/// <reference path="../wpt.ts" />
/// <reference path="../../modules/eformWrapper/eformWrapperCommon.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.EFormHandler";
        let WaitFormMode;
        (function (WaitFormMode) {
            WaitFormMode[WaitFormMode["NEW"] = 0] = "NEW";
            WaitFormMode[WaitFormMode["EXISTING"] = 1] = "EXISTING";
        })(WaitFormMode || (WaitFormMode = {}));
        class ComponentEFormHandler extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config, formSavedCallback = null, hideLoaderCallback = null, showLoaderCallback = null) {
                super(core, container, parent);
                this._commonLoaded = null;
                this._hideLoaderCallback = null;
                this._showLoaderCallback = null;
                this._formSavedCallback = null;
                this._iframeHolder = null;
                this._origin = null;
                this._eformWindow = null;
                this._currentFormMode = null;
                this._currentDocId = null;
                this._currentForm = null;
                this._formData = null;
                this._emptyOptionTranslation = null;
                this._config = null;
                this._currentAfterChangesCheckAction = null;
                this._isReady = null;
                this._isWaitingReloadForm = null;
                this._waitingFormMode = null;
                this._modalSession = null;
                this._currentFormData = null;
                this.showFormDocument = (docId, formData) => {
                    this._log.info("EFormHandlerComponent.showFormDocument()");
                    this._currentDocId = docId;
                    this._formData = formData;
                    if (this._isReady) {
                        this._currentFormMode = WPTNamespace.Utilities.EForms.EFormMode.EXISTING_FORM;
                        this.reloadForm();
                    }
                    else {
                        this._isWaitingReloadForm = true;
                        this._waitingFormMode = WaitFormMode.EXISTING;
                    }
                };
                this.showFormTemplate = (formName, formData) => {
                    this._log.info("EFormHandlerComponent.showFormTemplate()");
                    this._currentForm = formName;
                    this._formData = formData;
                    if (this._isReady) {
                        this._currentFormMode = WPTNamespace.Utilities.EForms.EFormMode.NEW_FORM;
                        this.reloadForm();
                    }
                    else {
                        this._isWaitingReloadForm = true;
                        this._waitingFormMode = WaitFormMode.NEW;
                    }
                };
                this.checkChangesAndRun = (action) => {
                    this._log.info("EFormHandlerComponent.checkChangesAndRun()");
                    if (this._currentFormMode == null) {
                        action();
                    }
                    else {
                        this._currentAfterChangesCheckAction = action;
                        let changesRequestMsg = {
                            Command: WPTNamespace.Utilities.EForms.WrapperCommand.CHANGES_REQUEST
                        };
                        this._eformWindow.postMessage(changesRequestMsg, this._origin);
                    }
                };
                this.reloadForm = () => {
                    this._log.info("EFormHandlerComponent.reloadForm()");
                    if (this._currentFormMode != null) {
                        if (this._isReady) {
                            if (this._showLoaderCallback) {
                                this._showLoaderCallback();
                            }
                            this._iframeHolder.src = './assets/wpt/html/eformWrapper.html?ver=' + this._core.getGatewayVersion();
                        }
                        else {
                            this._isWaitingReloadForm = true;
                        }
                    }
                };
                this.clearView = () => {
                    this._log.info("EFormHandlerComponent.clearView()");
                    if (this._iframeHolder) {
                        this._iframeHolder.innerHTML = "";
                        this._iframeHolder.src = "";
                    }
                };
                this.resetEformWindow = () => {
                    this._log.info("EFormHandlerComponent.resetEformWindow()");
                    this._eformWindow = this._iframeHolder.contentWindow;
                };
                this._commonJavascriptLoaded = () => {
                    this._log.info("EFormHandlerComponent._commonJavascriptLoaded()");
                    this._commonLoaded = true;
                    if (ComponentEFormHandler.Html != null) {
                        this._readyToPresent = true;
                        if (this._waitingToPresent)
                            this._present();
                    }
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("EFormHandlerComponent._storeHtml()");
                    ComponentEFormHandler.Html = htmlData;
                    if (this._commonLoaded) {
                        this._readyToPresent = true;
                        if (this._waitingToPresent)
                            this._present();
                    }
                };
                this._handleChangesResponse = (hasChanges) => {
                    this._log.info("EFormHandlerComponent._handleChangesResponse()");
                    if (hasChanges) {
                        this._core.Helper.presentWarningContinueModal('STR_WPT_CHANGED_DATA_MESSAGE', this._currentAfterChangesCheckAction);
                    }
                    else {
                        this._currentAfterChangesCheckAction();
                    }
                };
                this._messageHandler = (event) => {
                    // check origin
                    if (event.origin != this._origin) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got message from unexpected origin: " + event.origin);
                        }
                        return;
                    }
                    // check source
                    if (event.source != this._eformWindow) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got message from unexpected source: " + event.source);
                        }
                        return;
                    }
                    this._log.info("EFormHandlerComponent._messageHandler()");
                    if (this._parent && this._log.isTraceEnabled()) {
                        this._log.trace("message for " + this._parent.getHandle());
                    }
                    let message = event.data;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at command: " + WPTNamespace.Utilities.EForms.WrapperCommand[message.Command]);
                    }
                    switch (message.Command) {
                        case WPTNamespace.Utilities.EForms.WrapperCommand.READY:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("wrapper is ready");
                            }
                            let formContent = {
                                Command: WPTNamespace.Utilities.EForms.WrapperCommand.FORM_CONTENT,
                                Mode: this._currentFormMode,
                                Locale: this._core.Locale.getSelectedLocale().LocaleCode,
                                LangCode: this._core.Locale.getSelectedLocale().LangFileCode,
                                Content: this._formData,
                                UserVariables: this._core.Context.ArchivePrefillValues
                            };
                            switch (this._currentFormMode) {
                                case WPTNamespace.Utilities.EForms.EFormMode.NEW_FORM:
                                    formContent.FormName = this._currentForm;
                                    break;
                                case WPTNamespace.Utilities.EForms.EFormMode.EXISTING_FORM:
                                    formContent.DocId = this._currentDocId;
                                    break;
                                default:
                                    console.warn("unknown eform mode: " + WPTNamespace.Utilities.EForms.EFormMode[this._currentFormMode]);
                                    break;
                            }
                            this._eformWindow.postMessage(formContent, this._origin);
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.FORM_FINISHED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got form fished");
                            }
                            if (this._hideLoaderCallback) {
                                this._hideLoaderCallback();
                            }
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.FORM_VALUES:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got form values");
                            }
                            let formValues = message;
                            this._handleSaveEForm(formValues.Fields);
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.FILE_UPLOAD_INFO:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got file upload info");
                            }
                            let uploadInfos = message;
                            let keywords = WPTNamespace.Utilities.EForms.EFormHelper.transformFormFields(uploadInfos.Fields);
                            let fileInfo = uploadInfos.FileUpload;
                            let fileName = fileInfo.FileName;
                            let file = fileInfo.File;
                            let fileType = fileName.substring(fileName.lastIndexOf('.') + 1);
                            let requestUpload = {
                                KeywordRecords: [{ Type: "StandAlone", Keywords: keywords }],
                                DocType: fileInfo.DocType,
                                FileType: fileType
                            };
                            let request = JSON.stringify(requestUpload);
                            let formData = new FormData();
                            formData.append("request", request);
                            formData.append('file', file);
                            let headers = {
                                "Content-Type": "multipart/form-data"
                            };
                            this._core.Loader.genericServiceCallWithData('/Upload.svc/rest/MultiPartUploadDocument', formData, this._finishedUpload, headers, this._errorUpload, this._failedUpload);
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.AUTOFILL_INFO:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got autofill info");
                            }
                            let autofillInfo = message;
                            let autofillId = this._core.Functions.safeEncodeURIComponent(autofillInfo.AutofillId);
                            this._core.Loader.genericServiceCall('/Config.svc/rest/GetAutoFillKeywordSet/' + autofillId, this._responseAutofill.bind(this, autofillInfo.AutofillCount));
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.AUTOFILL_VALUE_REQUEST:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got autofill value request");
                            }
                            let autofillValueMsg = message;
                            let requestData = {
                                Name: autofillValueMsg.Name,
                                Value: autofillValueMsg.Value
                            };
                            this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/GetKeysetData', JSON.stringify(requestData), this._responseAutofillValues.bind(this, autofillValueMsg.Count));
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.SIZE_RESPONSE:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got size response");
                            }
                            let sizeMessage = message;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("setting height to: " + sizeMessage.Height);
                            }
                            this._iframeHolder.style.height = sizeMessage.Height + "px";
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.DATASET_REQUEST:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got dataset request");
                            }
                            let datasetMsg = message;
                            this._getDatasets(datasetMsg.Datasets);
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.CHANGES_RESPONSE:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got changes response");
                            }
                            let changesMsg = message;
                            this._handleChangesResponse(changesMsg.HasChanges);
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.FORM_SCRIPT_LOAD_FAILED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got script load error");
                            }
                            if (this._parent) {
                                let scriptLoadFailedMsg = message;
                                let loadMsg = this._core.Locale.getTranslation("STR_WPT_FORMSCRIPT_LOAD_FAILED_MSG") + ": " + scriptLoadFailedMsg.ScriptName;
                                this._parent.addError(loadMsg);
                            }
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.FORM_SCRIPT_EVAL_FAILED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got script eval error");
                            }
                            if (this._parent) {
                                let scriptEvalFailedMsg = message;
                                let evalMsg = this._core.Locale.getTranslation("STR_WPT_FORMSCRIPT_EVAL_FAILED_MSG") + ": " + scriptEvalFailedMsg.ScriptError.name + " - " + scriptEvalFailedMsg.ScriptError.message;
                                this._parent.addError(evalMsg);
                            }
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.SHOW_BUSY:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got show busy");
                            }
                            this._showBusyModal();
                            break;
                        case WPTNamespace.Utilities.EForms.WrapperCommand.SUBMIT_FINISHED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got submit finished");
                            }
                            let finishMsg = message;
                            this._handleSubmitResult(finishMsg.ErrorMessages);
                            break;
                        default:
                            console.warn("unknown command: " + WPTNamespace.Utilities.EForms.WrapperCommand[message.Command]);
                            break;
                    }
                };
                this._handleSaveEForm = (fields) => {
                    this._log.info("EFormHandlerComponent._handleSaveEForm()");
                    if (this._currentFormMode === WPTNamespace.Utilities.EForms.EFormMode.EXISTING_FORM &&
                        (this._config == null || !this._config.hasOwnProperty('DisableFormEditingMessage') || !this._config.DisableFormEditingMessage)) {
                        this._core.Helper.presentWarningContinueModal('STR_WPT_FORM_SAVE_CHANGES', this._savingEForm.bind(this, fields));
                    }
                    else {
                        this._savingEForm(fields);
                    }
                };
                this._savingEForm = (fields) => {
                    this._log.info("EFormHandlerComponent._savingEForm()");
                    this._currentFormData = null;
                    let requestForm = {
                        FormFields: fields
                    };
                    switch (this._currentFormMode) {
                        case WPTNamespace.Utilities.EForms.EFormMode.NEW_FORM:
                            requestForm.Name = this._currentForm;
                            requestForm.ItemNum = 0;
                            break;
                        case WPTNamespace.Utilities.EForms.EFormMode.EXISTING_FORM:
                            requestForm.Name = null;
                            requestForm.ItemNum = this._currentDocId;
                            break;
                        default:
                            console.warn("unknown eform mode: " + WPTNamespace.Utilities.EForms.EFormMode[this._currentFormMode]);
                            break;
                    }
                    if (this._config !== null && this._config.hasOwnProperty('SubmitFormCallback') && this._config.SubmitFormCallback) {
                        this._config.SubmitFormCallback(requestForm);
                    }
                    else {
                        this._core.Loader.genericServiceCallWithData('/Forms.svc/rest/SaveEForm', JSON.stringify(requestForm), this._savedEForm, null, this._errorEForm, this._failedEForm);
                    }
                };
                this._responseAutofill = (autofillCount, response) => {
                    this._log.info("EFormHandlerComponent._responseAutofill()");
                    if (response.hasOwnProperty('AutoFillKeywordSet') && response.AutoFillKeywordSet != null) {
                        let autofillResponse = {
                            Command: WPTNamespace.Utilities.EForms.WrapperCommand.AUTOFILL_RESPONSE,
                            Id: response.AutoFillKeywordSet.Id,
                            Name: response.AutoFillKeywordSet.Name,
                            PrimaryKeyword: response.AutoFillKeywordSet.PrimaryKeyword.Name,
                            Count: autofillCount
                        };
                        this._eformWindow.postMessage(autofillResponse, this._origin);
                    }
                };
                this._responseAutofillValues = (count, response) => {
                    this._log.info("EFormHandlerComponent._responseAutofillValues()");
                    if (response.hasOwnProperty('DataSet') && response.DataSet != null) {
                        if (response.DataSet.length === 1) {
                            this._datasetSelected(count, response.DataSet[0]);
                        }
                        else if (response.DataSet.length > 1) {
                            this._core.Helper.presentAutofillDatasetSelectionModal(WPTNamespace.ModalType.FIRST, response.DataSet, this._datasetSelected.bind(this, count));
                        }
                    }
                };
                this._datasetSelected = (count, dataset) => {
                    this._log.info("EFormHandlerComponent._datasetSelected()");
                    let autofillResponse = {
                        Command: WPTNamespace.Utilities.EForms.WrapperCommand.AUTOFILL_VALUE_RESPONSE,
                        Dataset: dataset.Keywords,
                        Count: count
                    };
                    this._eformWindow.postMessage(autofillResponse, this._origin);
                };
                this.changesSaved = () => {
                    this._log.info("EFormHandlerComponent.changesSaved()");
                    let changesSavedMsg = {
                        Command: WPTNamespace.Utilities.EForms.WrapperCommand.CHANGES_SAVED
                    };
                    this._eformWindow.postMessage(changesSavedMsg, this._origin);
                };
                this._savedEForm = (formData) => {
                    this._log.info("EFormHandlerComponent._savedEForm()");
                    this._currentFormData = formData;
                    this.changesSaved();
                };
                this._errorEForm = (url, status, text) => {
                    this._log.info("EFormHandlerComponent._errorEForm()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_FORM_SUBMIT_FAILED_MSG');
                    let msgBody = msgPrefix + ": " + url + " - " + text;
                    let errorMsg = {
                        Command: WPTNamespace.Utilities.EForms.WrapperCommand.CHANGES_FAILED,
                        ErrorMessage: msgBody
                    };
                    this._eformWindow.postMessage(errorMsg, this._origin);
                };
                this._failedEForm = (formData) => {
                    this._log.info("EFormHandlerComponent._failedEForm()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_FORM_SUBMIT_FAILED_MSG');
                    let msg = msgPrefix + ": ";
                    if (formData.hasOwnProperty('Connection') && formData.Connection.hasOwnProperty('Message')) {
                        msg += formData.Connection.Message;
                    }
                    let errorMsg = {
                        Command: WPTNamespace.Utilities.EForms.WrapperCommand.CHANGES_FAILED,
                        ErrorMessage: msg
                    };
                    this._eformWindow.postMessage(errorMsg, this._origin);
                };
                this._finishedUpload = (docData) => {
                    this._log.info("EFormHandlerComponent._finishedUpload()");
                    let uploadMsg = {
                        Command: WPTNamespace.Utilities.EForms.WrapperCommand.FILE_UPLOAD_RESULT,
                        Successful: true,
                        ErrorMessage: ""
                    };
                    this._eformWindow.postMessage(uploadMsg, this._origin);
                };
                this._errorUpload = (url, status, text) => {
                    this._log.info("EFormHandlerComponent._errorUpload()");
                    let msg = this._core.Locale.getTranslation('STR_WPT_UPLOAD_FAILED') + ": " + url + " - " + text;
                    let uploadMsg = {
                        Command: WPTNamespace.Utilities.EForms.WrapperCommand.FILE_UPLOAD_RESULT,
                        Successful: false,
                        ErrorMessage: msg
                    };
                    this._eformWindow.postMessage(uploadMsg, this._origin);
                };
                this._failedUpload = (docData) => {
                    this._log.info("EFormHandlerComponent._failedUpload()");
                    let msg = this._core.Locale.getTranslation('STR_WPT_UPLOAD_FAILED') + ": ";
                    if (docData.hasOwnProperty('MultiPartUploadDocumentResult') && docData.MultiPartUploadDocumentResult.hasOwnProperty('Connection') && docData.MultiPartUploadDocumentResult.Connection.hasOwnProperty('Message')) {
                        msg += docData.MultiPartUploadDocumentResult.Connection.Message;
                    }
                    let uploadMsg = {
                        Command: WPTNamespace.Utilities.EForms.WrapperCommand.FILE_UPLOAD_RESULT,
                        Successful: false,
                        ErrorMessage: msg
                    };
                    this._eformWindow.postMessage(uploadMsg, this._origin);
                };
                this._showBusyModal = () => {
                    this._log.info("EFormHandlerComponent._showBusyModal()");
                    let modalSession = 'form-submit-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                        this._modalSession = modalSession;
                    }
                };
                this._hideBusyModal = () => {
                    this._log.info("EFormHandlerComponent._hideBusyModal()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                };
                this._handleSubmitResult = (errors) => {
                    this._log.info("EFormHandlerComponent._handleSubmitResult()");
                    let resultFn = null;
                    let instance = this;
                    if (errors.length == 0) {
                        resultFn = function () {
                            if (instance._config == null || !instance._config.hasOwnProperty('DisableFormSavedMessage') || !instance._config.DisableFormSavedMessage) {
                                instance._core.Helper.presentSuccessModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_FORM_SAVED');
                            }
                            if (instance._formSavedCallback) {
                                instance._formSavedCallback(instance._currentFormData);
                            }
                        };
                    }
                    else {
                        resultFn = function () {
                            let msgPrefix = instance._core.Locale.getTranslation('STR_WPT_FORM_ERROR_MSG');
                            let msgBody = msgPrefix + ".\n";
                            errors.forEach(err => {
                                msgBody += "\n\t" + err;
                            });
                            instance._core.Helper.presentWarningServiceModal("STR_WPT_FORM", "STR_WPT_ERROR", msgBody);
                        };
                    }
                    if (this._modalSession) {
                        let modal = this._core.getModal(this._modalSession);
                        modal.JQ.one('hidden.bs.modal', function () {
                            resultFn();
                        });
                        this._hideBusyModal();
                    }
                    else {
                        resultFn();
                    }
                };
                this._getDatasets = (datasets) => {
                    this._log.info("EFormHandlerComponent._getDatasets()");
                    this._core.OBHelper.LoadKeywordTypes(this._processDatasets.bind(this, datasets));
                };
                this._processDatasets = (datasets) => {
                    this._log.info("EFormHandlerComponent._processDatasets()");
                    datasets.forEach(rawSetName => {
                        let safeSetName = this._core.Functions.safeEncodeURIComponent(rawSetName);
                        if (this._emptyOptionTranslation == null) {
                            this._emptyOptionTranslation = this._core.Locale.getTranslation('STR_WPT_SELECT_OPTION');
                        }
                        let datasetValues = [];
                        if (this._core.OBHelper.KeywordTypeNames.indexOf(safeSetName) > -1) {
                            if (this._core.OBHelper.KeywordTypeMap[safeSetName].DataSet.length > 0) {
                                datasetValues.push(...this._core.OBHelper.KeywordTypeMap[safeSetName].DataSet);
                            }
                        }
                        let datasetResponse = {
                            Command: WPTNamespace.Utilities.EForms.WrapperCommand.DATASET_RESPONSE,
                            DatasetName: safeSetName,
                            EmptyValue: this._emptyOptionTranslation,
                            Dataset: datasetValues
                        };
                        this._eformWindow.postMessage(datasetResponse, this._origin);
                    });
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("EFormHandlerComponent::constructor");
                this._config = config;
                this._hideLoaderCallback = hideLoaderCallback;
                this._showLoaderCallback = showLoaderCallback;
                this._formSavedCallback = formSavedCallback;
                this._isReady = false;
                this._isWaitingReloadForm = false;
                this._commonLoaded = false;
                core.Loader.loadVersionedJS('./assets/wpt/js/modules/eformWrapper/eformWrapperCommon.min.js', this._commonJavascriptLoaded);
                if (!ComponentEFormHandler.Html) {
                    core.Loader.getVersionedHTML('widgets/components/eformHandler.html', this._storeHtml, core.Helper.missingHtmlErrorCallback);
                }
                else if (this._commonLoaded) {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            _present() {
                this._log.info("EFormHandlerComponent._present()");
                this._container.innerHTML = ComponentEFormHandler.Html;
                this._iframeHolder = this._container.querySelector('#eformContentHolder');
                this._origin = window.origin;
                this._eformWindow = this._iframeHolder.contentWindow;
                window.addEventListener('message', this._messageHandler);
                this._isReady = true;
                if (this._log.isTraceEnabled()) {
                    this._log.trace("eform handler ready, checking actions waiting...");
                }
                if (this._isWaitingReloadForm) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("reloading form...");
                    }
                    if (this._currentFormMode == null) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("setting missing form mode...");
                        }
                        switch (this._waitingFormMode) {
                            case WaitFormMode.EXISTING:
                                this._currentFormMode = WPTNamespace.Utilities.EForms.EFormMode.EXISTING_FORM;
                                break;
                            case WaitFormMode.NEW:
                            default:
                                this._currentFormMode = WPTNamespace.Utilities.EForms.EFormMode.NEW_FORM;
                        }
                    }
                    this.reloadForm();
                }
            }
        }
        ComponentEFormHandler.Html = null;
        Widgets.ComponentEFormHandler = ComponentEFormHandler;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
